export default __webpack_public_path__ + "static/media/elo.35eb34b2.svg";